import { render } from "./JoinOurteam.vue?vue&type=template&id=45c78553&scoped=true"
import script from "./JoinOurteam.vue?vue&type=script&lang=js"
export * from "./JoinOurteam.vue?vue&type=script&lang=js"

import "./JoinOurteam.vue?vue&type=style&index=0&id=45c78553&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c78553"]])

export default __exports__